module.exports = __webpack_public_path__ + "static/media/hypokaustenheizung2_tn.6ad39aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/hypokaustenheizung2_tn.jpg
// module id = 772
// module chunks = 0